module.exports = __webpack_public_path__ + "img/p2-p4-juanzhou.c6676b2b.png";